<template>
  <label class="aoformlabel" :class="{'aoformlabel_checkboxmode': checkboxmode}" :tabindex="-1">
    <span v-if="text" class="aoformlabel__text">{{text}}</span>
    <slot />
    <span v-if="checkboxmode" class="aoformlabel__descr" v-html="descr"></span>
    <span class="aoformlabel__error" v-if="error">{{error}}</span>
  </label>
</template>
<script>
export default {
  props: {
    text: {type: String},
    error: {type: String},
    checkboxmode: {type: Boolean, default: false},
    descr: {type: String}
  }
}
</script>

<style lang="sass">
.aoformlabel
  width: 100%
  display: block
  position: relative
  margin-bottom: 41px
  outline: none
  &:focus-visible
    outline: auto
  &_checkboxmode
    border: none !important
    display: flex
    align-items: flex-start
  @include from(breakpoints.$formMob)
    margin-bottom: 37px
  &__text
    display: block
    font-size: 10px
    line-height: 24px
    letter-spacing: .1em
    margin-bottom: 4px
  &__descr
    margin-left: 16px
    font-weight: 300
    font-size: 14px
    line-height: 24px

  transition: border-color .3s ease-out
  border-bottom: 2px solid colors.$gray
  &:focus-within, &.filled
    border-color: black
  &:focus:not(:focus-visible)
    outline: none
  &:focus-within
    position: relative
    z-index: 3
    .aoformfield_witharrow svg
      transform: rotateX(180deg)
  &:focus-within .aoformdroplist
    pointer-events: auto
    opacity: 1
  &:not(:focus-within) .aoformdroplist
    transition: pointer-events .05s, opacity .05s
  &__error
    position: absolute
    white-space: nowrap
    top: calc(100% + 5px)
    left: 0
    font-size: 12px
    line-height: 24px
    letter-spacing: 0.02em
    color: colors.$red
</style>